import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { MainRoutes } from './enums';

@Injectable({
  providedIn: 'root',
})
export class AppleMapsOauthGuard {
  constructor(private router: Router) {
  }

  /**
   * Checks if we have a valid 'success' query param, otherwise route to /home
   * @param route
   * @param state
   */
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (route.queryParams?.success === 'true' || route.queryParams?.success === 'false') {
      return true;
    } else {
      console.warn('Missing valid success query param, redirecting to /home');
      return this.router.createUrlTree([MainRoutes.HOME]);
    }
  }

}
